import omitBy from 'lodash/omitBy';
import get from 'lodash/get';

var clearCash = function clearCash(client, types) {
  //TODO: perhaps add cache to 'bootstrapper data access layer', or extend client interface @TECHDEPT
  //'client.cache' selector is for wrapped bootstrapper client, 'cache' is for plain client
  var cache = get(client, 'client.cache') || get(client, 'cache');
  if (cache) {
    var cacheData = cache.extract();
    //TODO: perhaps take this form schema  -  annotation? some kind of pros?; @TECHDEPT
    var clearedData = omitBy(cacheData, function (_ref) {
      var __typename = _ref.__typename;
      return types.indexOf(__typename) !== -1;
    });
    cache.restore(clearedData);
  }
};

export default clearCash;